import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Thanks = () => {
  const { t } = useTranslation();

  return (
    <div>
      <main className="page-content page-content-ones">
        <div className="tm-section tm-my-account-area bg-white tm-padding-section wishlist-section-ones">
          <div className="container">
            <div className="tm-myaccount">
              <div className="tab-content" id="account-ontent">
                <div
                  className="tab-pane fade show active"
                  id="account-dashboard"
                  role="tabpanel"
                  aria-labelledby="account-dashboard-tab"
                >
                  <div className="tm-myaccount-dashboard1">
                    <div className="cart-box-two">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <div className="my-wishlist my-wishlist-one contact-form thank-hadding">
                            <h4> {t("T1")} 😇 </h4>
                            <p> {t("T2")}</p>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-8 col-md-6">
                          <div className="cart-box1 cart-box1-frist">
                            <div className="row align-items-center">
                              <div className="col-lg-2 col-3">
                                <div className="cart-photo">
                                  <h2>
                                    <img src="assets/images/card-photo.jpg" />
                                  </h2>
                                </div>
                              </div>
                              <div className="col-lg-10 col-9">
                                <div className="cart-text">
                                  {/* <button class="tm-wishlist-removeproduct remove-btn"><i class="ion-close"></i></button> */}
                                  <h2> {t("T3")}</h2>
                                  <h3>
                                    {" "}
                                    ₹550 <span>₹1100</span>
                                  </h3>
                                  <h4>
                                    <span> {t("T4")}: 10XL</span>
                                  </h4>
                                  <h4>
                                    <span> {t("T5")}: 1.3g</span>
                                  </h4>
                                  {/* <h4>
																	<div class="quantity">
																		<button class="minus" aria-label="Decrease">&minus;</button>
																		<input type="number" class="input-box" value="1" min="1" max="10">
																		<button class="plus" aria-label="Increase">&plus;</button>
																	</div>
																</h4> */}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="cart-box1 cart-box1-frist">
                            <div className="row align-items-center">
                              <div className="col-lg-2 col-3">
                                <div className="cart-photo">
                                  <h2>
                                    <img src="assets/images/brandlogo-jj.png" />
                                  </h2>
                                </div>
                              </div>
                              <div className="col-lg-10 col-9">
                                <div className="cart-text">
                                  {/* <button class="tm-wishlist-removeproduct remove-btn"><i class="ion-close"></i></button> */}
                                  <h2> {t("T3")}</h2>
                                  <h3>
                                    {" "}
                                    ₹1350 <span>₹2200</span>
                                  </h3>
                                  <h4>
                                    <span> {t("T4")}: 10XL</span>
                                  </h4>
                                  <h4>
                                    <span> {t("T5")}: 1.3g</span>
                                  </h4>
                                  {/* <h4>
																	<div class="quantity">
																		<button class="minus" aria-label="Decrease">&minus;</button>
																		<input type="number" class="input-box" value="1" min="1" max="10">
																		<button class="plus" aria-label="Increase">&plus;</button>
																	</div>
																</h4> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="cart-right">
                            <div className="my-wishlist my-wishlist-one address-icon">
                              <h4>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 384 512"
                                >
                                  {/*!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                                  <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                </svg>
                                {t("T6")}
                              </h4>
                            </div>
                            <div className="cart-box2 cart-box22">
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="two-left two-left-one">
                                    <h2 className="address-men">
                                    {t("T7")}
                                    </h2>
                                    <h2>+91 9999999999</h2>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="my-wishlist my-wishlist-one">
                                <h4> {t("C13")}</h4>
                              </div>
                              <div className="cart-box2">
                                <div className="row">
                                  <div className="col-lg-6 col-6">
                                    <div className="two-left">
                                      <h2> {t("C14")}</h2>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-6">
                                    <div className="two-right">
                                      <h2>+ ₹1900</h2>
                                    </div>
                                  </div>
                                </div>
                                <div className="row card-right-center">
                                  <div className="col-lg-6 col-6">
                                    <div className="two-left">
                                      <h2> {t("C15")}</h2>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-6">
                                    <div className="two-right">
                                      <h2 className="discount-text">- ₹350</h2>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="cart-box3">
                                <div className="row card-right-center">
                                  <div className="col-lg-6 col-6">
                                    <div className="two-left two-left1">
                                      <h2> {t("C17")}</h2>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-6">
                                    <div className="two-right two-right1">
                                      <h2>₹1550</h2>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <Link
                                to="/Myorder"
                                className="tm-button tm-button22 thanks-btn tm-button-dark"
                              >
                                 {t("T8")}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="account-orders"
                  role="tabpanel"
                  aria-labelledby="account-orders-tab"
                >
                  <div className="tm-myaccount-orders">
                    <div className="table-responsive">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th className="tm-myaccount-orders-col-id">
                             {t("C20")}
                            </th>
                            <th className="tm-myaccount-orders-col-date">
                            {t("C21")}
                            </th>
                            <th className="tm-myaccount-orders-col-status">
                            {t("C22")}
                            </th>
                            <th className="tm-myaccount-orders-col-total">
                            {t("C23")}
                            </th>
                            <th className="tm-myaccount-orders-col-view">
                            {t("C24")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>#12345</td>
                            <td>{t("C25")}</td>
                            <td>{t("C26")}</td>
                            <td>{t("C27")}</td>
                            <td>
                              <a href="#" className="tm-button tm-button-small">
                              {t("C24")}
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>#12346</td>
                            <td>{t("C25")}</td>
                            <td>{t("C26")}</td>
                            <td>{t("C28")}</td>
                            <td>
                              <a href="#" className="tm-button tm-button-small">
                              {t("C24")}
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="account-address"
                  role="tabpanel"
                  aria-labelledby="account-address-tab"
                >
                  <div className="tm-myaccount-address">
                    <p>
                      <b>
                      {t("C29")}
                      </b>
                    </p>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="tm-myaccount-address-billing">
                          <a href="#" className="edit-button">
                          {t("C36")}
                          </a>
                          <h3>{t("C30")}</h3>
                          <address>
                          {t("C31")}
                            <br />
                            
                            {t("C32")}
                            <br />
                            {t("C33")} <br />
                            {t("C34")} <br />
                            {t("C35")}
                          </address>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 mt-30 mt-md-0">
                        <div className="tm-myaccount-address-shipping">
                          <a href="#" className="edit-button">
                          {t("C36")}
                          </a>
                          <h3>{t("C37")}</h3>
                          <address>
                          {t("C31")}
                            <br />
                            {t("C32")}
                            <br />
                            {t("C33")} <br />
                            {t("C34")} <br />
                            {t("C35")}
                          </address>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="account-acdetails"
                  role="tabpanel"
                  aria-labelledby="account-acdetails-tab"
                >
                  <div className="tm-myaccount-acdetails">
                    <form action="#" className="tm-form tm-form-bordered">
                      <h4>{t("C38")}</h4>
                      <div className="tm-form-inner">
                        <div className="tm-form-field tm-form-fieldhalf">
                          <label htmlFor="acdetails-firstname">
                          {t("C39")}
                          </label>
                          <input type="text" id="acdetails-firstname" />
                        </div>
                        <div className="tm-form-field tm-form-fieldhalf">
                          <label htmlFor="acdetails-lastname">{t("C40")}</label>
                          <input type="text" id="acdetails-lastname" />
                        </div>
                        <div className="tm-form-field">
                          <label htmlFor="acdetails-displayname">
                          {t("C41")}
                          </label>
                          <input type="text" id="acdetails-displayname" />
                        </div>
                        <div className="tm-form-field">
                          <label htmlFor="acdetails-email">{t("C42")}</label>
                          <input type="email" id="acdetails-email" />
                        </div>
                        <div className="tm-form-field">
                          <label htmlFor="acdetails-password">
                          {t("C43")}
                          </label>
                          <input type="password" id="acdetails-password" />
                        </div>
                        <div className="tm-form-field">
                          <label htmlFor="acdetails-newpassword">
                          {t("C44")}
                          </label>
                          <input type="password" id="acdetails-newpassword" />
                        </div>
                        <div className="tm-form-field">
                          <label htmlFor="acdetails-confirmpass">
                          {t("C45")}
                          </label>
                          <input type="password" id="acdetails-confirmpass" />
                        </div>
                        <div className="tm-form-field">
                          <input
                            type="checkbox"
                            name="acdetails-agreeterms"
                            id="acdetails-agreeterms"
                          />
                          <label htmlFor="acdetails-agreeterms">
                          {t("C46")}
                          </label>
                        </div>
                        <div className="tm-form-field">
                          <button type="submit" className="tm-button">
                          {t("C47")}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Thanks;
